'use client';

import { useEffect, useRef } from 'react';
import { onOneTrustGroupsUpdated } from '../utils/onOneTrustGroupsUpdated';
type ConsentGroup = 'C0001' | 'C0002' | 'C0003' | 'C0004';
interface UseConsentGatedHtmlParams {
  html: string;
  selector?: string;
  dedupeId?: string;
  isEnabled?: boolean;
  consentGroup: ConsentGroup;
  onReady?: () => void;
}

/**
 * Loads inline/custom HTML via OneTrust once consent is granted.
 * Use this for integrations that are not a plain external `src` script.
 */
export function useConsentGatedHtml({
  html,
  dedupeId,
  onReady,
  consentGroup,
  selector = 'body',
  isEnabled = true
}: UseConsentGatedHtmlParams) {
  const onReadyRef = useRef(onReady);
  onReadyRef.current = onReady;
  useEffect(() => {
    if (!isEnabled || !html) {
      return;
    }
    let called = false;
    const init = () => {
      if (called) return;
      called = true;
      onReadyRef.current?.();
    };
    const insert = () => {
      if (called) {
        return;
      }
      if (dedupeId && document.getElementById(dedupeId)) {
        called = true;
        return;
      }
      if (window.OneTrust?.InsertHtml) {
        window.OneTrust.InsertHtml(html, selector, init, null, consentGroup);
      }
    };
    insert();
    return onOneTrustGroupsUpdated(insert);
  }, [isEnabled, html, selector, consentGroup, dedupeId]);
}